const Auxiliary = (props: any) => props.children;

export default Auxiliary;
